import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBankCard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 15,
			width: 26,
			height: 19,
			rx: 2,
			stroke: "#006464",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006464",
			d: "M11 19h26v4H11z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 15,
			y: 26,
			width: 4,
			height: 4,
			rx: 1,
			fill: "#006464"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 30,
			y: 27,
			width: 3,
			height: 2,
			rx: 1,
			fill: "#006464"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 26,
			y: 27,
			width: 3,
			height: 2,
			rx: 1,
			fill: "#006464"
		})
	]
});
export default SvgBankCard;
